<template>
  <div class="qu_index">
      <div class="qu_body">
          <van-image class="qu_falot" width=".95rem" height=".72rem" src="https://oss.mcloud.moveclub.cn/mpms/20210312/1615514637-604acc0df1ad5.png" />
          <div class="qu_header"></div>          
          <div class="qu_list">
            <div class="qu_t">题目描述</div>
            <div class="qu_title">{{questions.title}}</div>
            <div
                v-for="(item,ckey) in questions.content"
                :key="ckey"
                class="question-item van-ellipsis"
                :class="{selected:selected===ckey+1,correct:(selected===ckey+1 && questions.answer*1 ===ckey+1),wrong:selected===ckey+1 && questions.answer*1 !==ckey+1}"
                @click="selectAnswer(item,ckey)"
            >{{ckey|letters}}. {{item}}</div>
          </div>
          <div class="qu_footer"></div>
      </div>
  </div>
</template>
<script>
import { Image, Popup } from "vant";

export default {
  components: {
    VanImage: Image,
    Popup
  },
  name: "hpJoin",
  computed: {
  },
  filters: {
    letters(e) {
      let lettersarr = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
      ];
      return lettersarr[e];
    },
  },
  data() {
    return {
        questions:{},
        selected: '',
        disabled: false
    };
  },
  methods: {
    init: function () {
      this.$api.activity.hpGetques({matchid:this.$route.params.matchid}).then((res)=>{
        let data = res.data
        data.content = JSON.parse(res.data.content)
        this.questions = data
      })
    },
    selectAnswer(item, ckey) {
      if(this.disabled) return;
      this.disabled = true
      this.selected = ckey+1
      if(this.questions.answer*1===ckey+1){
        this.$api.activity.hpSubQues({matchid:this.$route.params.matchid,qid:this.questions.qid,answer:this.questions.answer}).then((res)=>{
          this.$toast.success('答题成功');
          this.$router.push({name:'hp_group', params: {matchid:this.$route.params.matchid}})
          this.disabled = true
        })
      }else{
        this.$toast.fail('答题错误');        
        let that = this
        setTimeout(()=>{
          that.disabled = false;
          that.selected = '';
          that.init();
        },1000)
        
      }
      // alert(1);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

